import { render, staticRenderFns } from "./feedbackorderModel.vue?vue&type=template&id=e5555b8c&scoped=true&"
import script from "./feedbackorderModel.vue?vue&type=script&lang=js&"
export * from "./feedbackorderModel.vue?vue&type=script&lang=js&"
import style0 from "./feedbackorderModel.vue?vue&type=style&index=0&id=e5555b8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5555b8c",
  null
  
)

export default component.exports